import React from 'react';
import { Tag } from 'rsuite';

import './pro-badge.scss';

export const ProBadge = ({ children }) => <Tag className="lf-pro-badge" color="cyan">{children}</Tag>;
